"use client";

import React, { useState, useEffect } from "react";
import { Menu } from "lucide-react";
import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "@/components/ui/navigation-menu";
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetTrigger } from "@/components/ui/sheet";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
function DesktopNav() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div data-section-id="123994" className="flex gap-6">
        {[1, 2, 3, 4].map((_, i) => <div key={i} data-index={i} className="h-5 w-20 animate-pulse bg-[#dcece9] rounded-none" />)}
      </div>;
  }
  return <NavigationMenu viewport={false} className="hidden md:flex">
      <NavigationMenuList className="gap-8">
        {menuItems.map((item, i) => <NavigationMenuItem key={item.id} data-index={i}>
            <NavigationMenuLink asChild>
              <Link to={item.href || "#"} className={cn("font-sans text-[14px] font-semibold uppercase tracking-[0.05em] transition-all duration-300 hover:-translate-y-0.5 focus:outline-none", item.label?.toLowerCase() === "home" || item.label?.toLowerCase() === "αρχική" ? "bg-[#fb5d43] text-white px-4 py-2 rounded-[4px] hover:bg-[#fb5d43]/90" : "text-[#f12100] hover:text-[#fb5d43]")}>
                {item.label}
              </Link>
            </NavigationMenuLink>
          </NavigationMenuItem>)}
      </NavigationMenuList>
    </NavigationMenu>;
}
function MobileNav() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="mt-8 flex flex-col gap-6">
        {[1, 2, 3, 4].map((_, i) => <div key={i} data-index={i} className="h-6 w-32 animate-pulse bg-[#dcece9] rounded-none" />)}
      </div>;
  }
  return <div className="mt-8 flex flex-col gap-6">
      {menuItems.map((item, i) => <div key={item.id} data-index={i}>
          <Link to={item.href || "#"} className={cn("font-sans text-lg font-bold uppercase tracking-widest transition-colors", item.label?.toLowerCase() === "home" || item.label?.toLowerCase() === "αρχική" ? "text-[#fb5d43]" : "text-[#f12100] hover:text-[#fb5d43]")}>
            {item.label}
          </Link>
        </div>)}
    </div>;
}
export default function SiteHeader() {
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll, {
      passive: true
    });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  return <header id="site-navigation" className={cn("sticky top-0 z-50 w-full transition-all duration-300 ease-in-out", isScrolled ? "bg-[#f0f9f8]/80 backdrop-blur-[12px] border-b border-[#dcece9] shadow-sm" : "bg-[#f0f9f8] border-b border-transparent")}>
      <div className="mx-auto flex h-24 w-full max-w-[1280px] items-center justify-between px-6 lg:px-8">
        {}
        <div className="flex-shrink-0">
          <Link to="/HomePage" className="group flex items-center gap-2 focus:outline-none">
            <span className="font-sans text-2xl font-extrabold tracking-tighter text-[#fb5d43] transition-opacity group-hover:opacity-90 md:text-3xl">
              MigratePro
            </span>
          </Link>
        </div>

        {}
        <MenuProvider menu_id="40">
          <DesktopNav />
        </MenuProvider>

        {}
        <div className="md:hidden">
          <Sheet>
            <SheetTrigger asChild>
              <Button variant="ghost" size="icon" className="text-[#fb5d43] hover:bg-[#dcece9] hover:text-[#fb5d43] focus-visible:ring-[#fb5d43]" aria-label="Άνοιγμα μενού">
                <Menu className="size-7" />
              </Button>
            </SheetTrigger>
            <SheetContent side="right" className="w-[300px] bg-[#f0f9f8] sm:w-[400px] rounded-none border-l-[#dcece9]">
              <SheetHeader className="text-left">
                <SheetTitle className="font-sans text-xl font-bold text-[#fb5d43]">
                  NAVIGATION
                </SheetTitle>
              </SheetHeader>
              <MenuProvider menu_id="40">
                <MobileNav />
              </MenuProvider>
            </SheetContent>
          </Sheet>
        </div>
      </div>
    </header>;
}